import { render, staticRenderFns } from "./RTPNormForm.vue?vue&type=template&id=16e2f5f1&"
import script from "./RTPNormForm.vue?vue&type=script&lang=js&"
export * from "./RTPNormForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e2f5f1')) {
      api.createRecord('16e2f5f1', component.options)
    } else {
      api.reload('16e2f5f1', component.options)
    }
    module.hot.accept("./RTPNormForm.vue?vue&type=template&id=16e2f5f1&", function () {
      api.rerender('16e2f5f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/RTPNormForm.vue"
export default component.exports